import { GuestGuard } from "app/features/authentication/guards/GuestGuard";
import AccountRecoveryScreen from "app/screens/authentication/AccountRecoveryScreen";

export default function AccountRecoveryPage() {
  return <GuestGuard>
    <AccountRecoveryScreen />
  </GuestGuard>;
}
